import { createAction, props } from '@ngrx/store';

import { Vehicle } from '@global/infrastructure/interfaces/vehicle';

export const carLookupSuccess = createAction(
  '[YourRegistration] Car Lookup Success',
  props<{ newVehicle: Vehicle }>()
);

export const updateCarDetails = createAction(
  '[YourRegistration] Update Car Details',
  props<{ updatedCarDetails: any }>()
);

export const resetCar = createAction(
  '[YourRegistration] Reset Car'
);

export const resetError = createAction(
  '[YourRegistration] Reset Error'
);

export type YourRegistrationActionsUnion = ReturnType<typeof carLookupSuccess | typeof updateCarDetails | typeof resetCar | typeof resetError>;

